var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-Form c-Form--Comments" }, [
    _vm.successMsg
      ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.successMsg))])])
      : _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.validateBeforeSubmit()
              }
            }
          },
          [
            _vm.formErrors.length
              ? _c("div", { staticClass: "c-Form__errors" }, [
                  _vm.formErrors.length > 1
                    ? _c(
                        "p",
                        [
                          _vm._v(
                            "\n          These fields are invalid :\n          "
                          ),
                          _vm._l(_vm.formErrors, function(error, index) {
                            return _c(
                              "span",
                              { key: index },
                              _vm._l(error, function(err, key) {
                                return _c("span", { key: key }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.convertText(key))
                                  ),
                                  index + 1 < _vm.formErrors.length
                                    ? _c("span", [_vm._v(",")])
                                    : _vm._e()
                                ])
                              }),
                              0
                            )
                          })
                        ],
                        2
                      )
                    : _c(
                        "p",
                        _vm._l(_vm.formErrors, function(error, index) {
                          return _c(
                            "span",
                            { key: index },
                            _vm._l(error, function(err, key) {
                              return _c("span", { key: key }, [
                                _vm._v(
                                  "\n              The " +
                                    _vm._s(_vm.convertText(key)) +
                                    " field is invalid\n          "
                                )
                              ])
                            }),
                            0
                          )
                        }),
                        0
                      )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("ValidationProvider", {
              attrs: { name: "firstName", rules: _vm.formatRules("firstName") },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var errors = ref.errors
                    return _c("div", {}, [
                      _c("label", { attrs: { for: "firstName" } }, [
                        _vm._v("\n          First Name "),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fieldDefs.firstName.value,
                              expression: "fieldDefs.firstName.value"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "Type your first name",
                            name: "firstName",
                            minlength: "2"
                          },
                          domProps: { value: _vm.fieldDefs.firstName.value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.fieldDefs.firstName,
                                "value",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("ValidationProvider", {
              attrs: { name: "lastName", rules: _vm.formatRules("lastName") },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var errors = ref.errors
                    return _c("div", {}, [
                      _c("label", { attrs: { for: "lastName" } }, [
                        _vm._v("\n          Last Name "),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fieldDefs.lastName.value,
                              expression: "fieldDefs.lastName.value"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "Type your last name",
                            name: "lastName"
                          },
                          domProps: { value: _vm.fieldDefs.lastName.value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.fieldDefs.lastName,
                                "value",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("ValidationProvider", {
              attrs: { name: "email", rules: _vm.formatRules("email") },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var errors = ref.errors
                    return _c("div", {}, [
                      _c("label", { attrs: { for: "email" } }, [
                        _vm._v("\n          Email Address "),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fieldDefs.email.value,
                              expression: "fieldDefs.email.value"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "Type your email address",
                            name: "email"
                          },
                          domProps: { value: _vm.fieldDefs.email.value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.fieldDefs.email,
                                "value",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("ValidationProvider", {
              attrs: { name: "country", rules: "" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var errors = ref.errors
                    return _c("div", {}, [
                      _c("label", { attrs: { for: "country" } }, [
                        _vm._v("\n          Country "),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fieldDefs.country.value,
                              expression: "fieldDefs.country.value"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "Type your country name",
                            name: "country"
                          },
                          domProps: { value: _vm.fieldDefs.country.value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.fieldDefs.country,
                                "value",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("ValidationProvider", {
              attrs: { name: "comment", rules: _vm.formatRules("comment") },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var errors = ref.errors
                    return _c("div", {}, [
                      _c("label", { attrs: { for: "comment" } }, [
                        _vm._v("\n          Comment\n          "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fieldDefs.comment.value,
                              expression: "fieldDefs.comment.value"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "Type your comment",
                            name: "comment"
                          },
                          domProps: { value: _vm.fieldDefs.comment.value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.fieldDefs.comment,
                                "value",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("ValidationProvider", {
              attrs: {
                name: "newsletter",
                rules: _vm.formatRules("newsletter")
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var errors = ref.errors
                    return _c("div", {}, [
                      _c(
                        "label",
                        {
                          staticClass: "checkbox",
                          attrs: { for: "newsletter" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.fieldDefs.newsletter.value,
                                expression: "fieldDefs.newsletter.value"
                              }
                            ],
                            attrs: { type: "checkbox", name: "newletter" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.fieldDefs.newsletter.value
                              )
                                ? _vm._i(_vm.fieldDefs.newsletter.value, null) >
                                  -1
                                : _vm.fieldDefs.newsletter.value
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.fieldDefs.newsletter.value,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.fieldDefs.newsletter,
                                        "value",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.fieldDefs.newsletter,
                                        "value",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.fieldDefs.newsletter,
                                    "value",
                                    $$c
                                  )
                                }
                              }
                            }
                          }),
                          _vm._v(
                            "\n          Please sign me up for the Another Tomorrow newsletter.\n        "
                          )
                        ]
                      )
                    ])
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("button", { staticClass: "c-Button c-Button--invert" }, [
              _vm._v("\n      Send Message\n    ")
            ])
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }